import { getRangeValue } from '@/packages/JsonQuery';

import { type ITagGroupConfig } from '../types';
import { getRangeText } from '../utils/getRangeText';

export const constructionYear: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value = getRangeValue('house_year')(jsonQuery);
    const rangeText = getRangeText(value);
    if (!rangeText) {
      return null;
    }

    return [
      {
        group: 'constructionYear',
        text: `Год постройки ${rangeText}`,
      },
    ];
  },
  delete({ onChange }) {
    onChange(
      {
        action: 'setConstructionYearMax',
        arguments: [null],
      },
      {
        action: 'setConstructionYearMin',
        arguments: [null],
      },
    );
  },
};
